// cd: header-drawer level-2 accordion
(function () {
  function closeSiblings(opened) {
    var list = opened.closest("ul.menu-drawer__menu");
    if (!list) return;
    list.querySelectorAll("details.drawer-menu-item-2[open]").forEach(function (d) {
      if (d !== opened) d.removeAttribute("open");
    });
  }
  document.addEventListener(
    "toggle",
    function (event) {
      var el = event.target;
      if (el && el.classList && el.classList.contains("drawer-menu-item-2") && el.open) {
        closeSiblings(el);
      }
    },
    true
  );
})();
